import React from 'react';

import {
    autoUpdate,
    flip,
    offset,
    Placement,
    shift,
    useClick,
    useDismiss,
    useFloating,
    useInteractions,
} from '@floating-ui/react';

interface IUseFloatingPositionProps {
    anchorRef: React.RefObject<HTMLElement>;
    isOpen?: boolean;
    onClose?: () => void;
    mainAxis?: number;
    crossAxis?: number;
    placement?: Placement;
}

export const useFloatingPosition = ({
    anchorRef,
    isOpen = true,
    onClose,
    mainAxis = 6,
    crossAxis = 0,
    placement = 'bottom-start',
}: IUseFloatingPositionProps) => {
    const { refs, floatingStyles, context } = useFloating({
        elements: {
            reference: anchorRef.current ?? undefined,
        },
        open: isOpen,
        onOpenChange: (open) => {
            if (!open) onClose?.();
        },
        middleware: [offset({ mainAxis, crossAxis }), flip(), shift()],
        placement,
        whileElementsMounted: autoUpdate,
    });

    const click = useClick(context);
    const dismiss = useDismiss(context);
    const { getFloatingProps } = useInteractions([click, dismiss]);

    return {
        refs,
        floatingStyles,
        getFloatingProps,
    };
};
